import { getStaticOptions, __, request } from "../utils";
import $ from "jquery";
import { locationRestCrossDismissDelete } from "../wp-api";
const DATA_MEMORIZE_CREATED = "crossSellingPointer";

class CrossSellingPointer {
  /* istanbul ignore next */
  constructor($handler, slug, action, position) {
    this.slug = void 0;
    this.action = void 0;
    this.position = void 0;
    this.$handler = void 0;
    this.slug = slug;
    this.action = action;
    this.position = position;
    this.$handler = $handler;
    this.init();
  }

  static waitForVisibleElement(selector, slug, action, position) {
    if (!this.isActionAvailable(slug, action)) {
      return false;
    }

    const $details = $(selector);

    if ($details.length && !$details.data(DATA_MEMORIZE_CREATED)) {
      $details.data(DATA_MEMORIZE_CREATED, true);
      new CrossSellingPointer($details, slug, action, position);
    }

    return $details.length > 0;
  }

  static isActionAvailable(slug, action) {
    var _getStaticOptions$cro, _getStaticOptions$cro2;

    return !!((_getStaticOptions$cro = getStaticOptions().cross) !== null && _getStaticOptions$cro !== void 0 && (_getStaticOptions$cro2 = _getStaticOptions$cro[slug]) !== null && _getStaticOptions$cro2 !== void 0 && _getStaticOptions$cro2[action]);
  }

  close(e, redirect) {
    e.preventDefault();
    const force = this.$handler.pointer("widget").find('input[type="checkbox"]').is(":checked");
    this.$handler.pointer("close");
    this.$handler.pointer("destroy"); // force means in this context, that we clicked "Rate now"

    if (redirect) {
      const {
        link
      } = this.getAction();
      window.open(link, "_blank");
    }

    request({
      location: locationRestCrossDismissDelete,
      params: {
        slug: this.slug,
        action: this.action,
        force
      }
    });
  }

  buttons() {
    const close = $("<a class=\"button\" href=\"#\">".concat(__("Not now"), "</a>")).click(e => {
      this.close(e, false);
    });
    const rateNow = $("<a class=\"button button-primary\" href=\"#\">".concat(__("Learn more!"), "</a>")).click(e => {
      this.close(e, true);
    });
    return $('<div class="real-utils-pointer-buttons" />').append(rateNow, close);
  }

  getAction() {
    var _getStaticOptions$cro3;

    return (_getStaticOptions$cro3 = getStaticOptions().cross) === null || _getStaticOptions$cro3 === void 0 ? void 0 : _getStaticOptions$cro3[this.slug][this.action];
  }

  init() {
    const {
      position
    } = this;
    const {
      title,
      description,
      image
    } = this.getAction();
    const neverAgainCheckbox = "<label><input type=\"checkbox\" /> ".concat(__("Never show this popup again"), "</label>");

    this.$handler.pointer({
      pointerClass: "wp-pointer real-utils-cross-pointer",
      content: "<h3>".concat(title, "</h3><p><img src=\"").concat(image, "\" />").concat(description).concat(neverAgainCheckbox, "</p>"),
      buttons: this.buttons.bind(this),
      position
    }).pointer("open") // Reposition when image is loaded completely
    .pointer("widget").find("img").get(0).onload = () => this.$handler.pointer("reposition");
  }

}

export { CrossSellingPointer };